export function waitUntil(promise, timeoutConfiguration = {}) {
    let timeoutId;
    const { timeout = 10 * 1000, timeoutMessage = `Timeout while waiting on event to happen.` } = timeoutConfiguration;
    return Promise.race([
        new Promise((_, reject) => {
            timeoutId = setTimeout(() => {
                reject(new Error(timeoutMessage));
            }, timeout);
        }),
        promise(),
    ]).then(result => {
        clearTimeout(timeoutId);
        return result;
    });
}
//# sourceMappingURL=waitUntil.js.map